export default {
    header: {
        self: {},
        items: [],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "fas fa-tachometer-alt",
                page: "dashboard",
            },
            {
                title: "Contratos",
                root: true,
                icon: "fas fa-file",
                page: "contrato",
            },
            {
                title: "Produtos",
                root: true,
                icon: "fas fa-box",
                page: "produto",
            },
            {
                title: "Acessos",
                root: true,
                bullet: "dot",
                icon: "fas fa-users",
                submenu: [
                    {
                        title: "Usuários",
                        page: "admin",
                    },
                    {
                        title: "Grupos de usuários",
                        page: "grupo",
                    },
                ],
            },
        ],
    },
};
